import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';



@customElement('search-file')
export class SimpleGreeting extends LitElement {
	static styles = css`

	p{
		font-size:14px !important;
	}

    ul{
		list-style-type: none;
		padding-left:0;
		padding-top:60px;
	}

	li{
		display: flex;
		gap:21px;
		margin-bottom:15px;
		align-items: center;

		i{
			
			font-size:18px;

			&.file-type-icon{
				max-width:25px;
				font-size:26px;
			}
		}
	}



	a{
		text-decoration:none;
		color: var(--color-primary);
	}

	h3{
		margin-top:3px;
		margin-bottom:5px;
		font-size:1.25rem;
	}

	p{
				margin-top:0;
		
	}
	.alert{
		max-width: 936px;
	}

	.input-group-text{
		background-color: transparent;
		border-right: none !important;
		color: var(--color-primary);
	}

	.input-group .form-control{
		border-left: none !important;
	}

	.search-input{
		/*max-width:800px;*/
		width: calc(100% - 180px);
		display: inline-block;
	}

	.download-all-row{
		margin-top:20px;

		i{
			margin-right:8px;
			font-size:16px;
		}
	}

	.btn-primary{
		--bs-btn-bg: var(--color-primary);
		--bs-btn-border-color: var(--color-primary);
		--bs-btn-hover-bg: #FFF;
		--bs-btn-hover-border-color: var(--color-primary);
		--bs-btn-hover-color: var(--color-primary);
	
	}
  `;

	@property()
	loaded = false;

	@property()
	stylesheetUrl: string = "";

	@property()
	category?: string = "";

	@property()
	public items: FileInfo[] = [];

	@property()
	public searchTerm: string = "";

	@property()
	public preparingDownload = false;

	firstUpdated() {
		this.search();

	}


	search() {

		this.loaded = false;



		fetch(`/umbraco/api/portal/listfiles`, {
			method: 'POST', // Specify the HTTP method as POST
			headers: {
				'Content-Type': 'application/json' // Set the content type of the request body
			},
			body: JSON.stringify({
				categoryId: this.category,
				searchTerm: this.searchTerm
			}) // Convert the JavaScript object to a JSON string
		})
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {
				this.items = data;


			})
			.catch(error => {

				console.error('Error:', error); // Handle any errors that occurred during the fetch
			}).finally(() => {

				this.loaded = true;
			});

		this.dispatchEvent(new CustomEvent('SearchEvent', {
			detail: {
				categoryId: this.category,
				searchTerm: this.searchTerm
			},
			bubbles: true,
			composed: true
		})
		);
	}

	handleInput(e: any) {
		
		this.searchTerm = e.target.value;
	}


	/**
	 * Zips up the files currently listed. Posted as a hidden form rather than fetched so the
	 * browser streams the zip straight to disk instead of buffering it in memory, and so a
	 * long list of ids is not squeezed into a URL.
	 */
	downloadAll() {

		if (this.preparingDownload || this.items.length === 0) {
			return;
		}
		this.preparingDownload = true;

		const frameName = `portal-download-${Date.now()}`;
		const frame = document.createElement('iframe');
		frame.name = frameName;
		frame.style.display = 'none';
		document.body.appendChild(frame);

		const form = document.createElement('form');
		form.method = 'POST';
		form.action = '/OwnersPortal/DownloadAll';
		form.target = frameName;
		form.style.display = 'none';
		form.appendChild(this.hiddenField('categoryId', this.category ?? ""));
		this.items.forEach(item => form.appendChild(this.hiddenField('fileIds', item.id)));

		// Appended to the document, not the shadow root, so the form can resolve its target frame
		document.body.appendChild(form);
		form.submit();
		form.remove();

		// A download fires no load event, and the server sends its headers before it starts
		// reading files, so the browser has taken ownership of it well before this clears
		window.setTimeout(() => {
			this.preparingDownload = false;
			frame.remove();
		}, 10000);

		this.trackDownload(`${this.items.length} files`, 'zip', form.action);
	}

	/** Media urls already carry a category, so the separator depends on the file type. */
	forceDownloadUrl(fileUrl: string) {
		return fileUrl + (fileUrl.includes('?') ? '&' : '?') + 'download=true';
	}

	hiddenField(name: string, value: string): HTMLInputElement {
		const field = document.createElement('input');
		field.type = 'hidden';
		field.name = name;
		field.value = value;
		return field;
	}


	trackDownload(fileName: string, fileExtension: string, linkUrl: string) {
		if (typeof gtag === 'function') {
			
			console.log('Tracking file download:', fileName, fileExtension, linkUrl);			
			gtag('event', 'file_download', {
				'file_name': fileName,
				'file_extension': fileExtension,
				'link_url': linkUrl,
				'event_category': 'download',
				'event_label': fileName
			});
		}
	}



	// Render the UI as a function of component state
	render() {
		return html`
		<link href="/CSS/Libs/fontawesome-pro-6.2.0/css/fontawesome.css" rel="stylesheet" />
		<link href="/CSS/Libs/fontawesome-pro-6.2.0/css/solid.css" rel="stylesheet" />
		<link href="/CSS/Libs/bootstrap-5.2/css/bootstrap.min.css" rel="stylesheet" />


		

		<div ?hidden=${this.items.length <= 1 && this.searchTerm === ""}>
		<div class="search-input">
		<div class="input-group">
		  <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-magnifying-glass"></i></span>
		  <input type="text" .value=${this.searchTerm} class="form-control" aria-label="Search" placeholder="Search" @input=${this.handleInput} @keydown=${(event: any) => { if (event.key == "Enter") { this.search() } }}> 
		</div>
</div>
<button class="btn btn-primary" style="transform:translateY(-2px);" @click=${this.search}>Search</button>&nbsp;<button class="btn btn-secondary" style="transform:translateY(-2px);" @click=${() => { this.searchTerm = ""; this.search() }}>clear</button>
</div>
<div class="download-all-row" ?hidden=${this.items.length <= 1}>
	<button class="btn btn-primary" ?disabled=${this.preparingDownload} @click=${this.downloadAll} title="Download all of the files listed below as a single zip">
		<i class="fa-solid ${this.preparingDownload ? "fa-spinner fa-spin" : "fa-file-zipper"}"></i>
		${this.preparingDownload ? "Preparing download..." : "Download All"}
	</button>
</div>
<div class="alert alert-primary my-5" ?hidden=${this.items.length > 0 || !this.loaded}>No results found</div>
	  <ul>
	  ${this.items.map((item) =>
			html`<li>
		 
		 <i class="fa-solid ${item.icon} file-type-icon"></i>
		 <div>
		  <h3><a .href="${item.fileUrl}" target="_blank" @click=${() => this.trackDownload(item.fileName, item.fileType, item.fileUrl)}>${item.fileName}</a> <a class="" .href="${this.forceDownloadUrl(item.fileUrl)}" aria-label="Download ${item.fileName}" title="Download ${item.fileName}" @click=${() => this.trackDownload(item.fileName, item.fileType, item.fileUrl)}><i class="fa-solid fa-download ms-3"></i></a></h3>
		 ${ item.fileDescription } 
		 
		</div>

		  </li>`
		)}
	  </ul>
	  `;
	}

}

export class FileInfo {
	public id: string = "";
	public fileName: string = "";
	public fileUrl: string = "";
	public fileDescription: string = "";
	public fileType: string = "";
	public icon: string = "";
}